import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
// import { User } from '@/api';
// 导入模块

import Menu from '@/store/modules/menu.js'
import Users from '@/store/modules/user.js'
// import getters from './getters'
Vue.use(Vuex)

export default new Vuex.Store(
  {
    modules: {
      Menu,
      Users
    },
    state: {
      // beforeUrl:'/api',
      // sidebar:true,//侧边栏展开
      messageNum: 0,
      languageType: 1, //浏览器语种
      tokenInfo: {},
      // l浏览器语种
      optionsLanguageList: [
        {
          label: 'English',
          value: 0
        },
        {
          label: '中文简体',
          value: 1
        }
      ],
      sidePath: '/overview/index',
      user: {}, //用户信息
      loginUser: {}, //登录用户
      showAside: false, //显示false隐藏true侧边栏
      overviewData: {
        xxCount: 0
      } //概览页数据
    },
    getters: {
      messageNum: state => state.messageNum,
      languageType: state => state.languageType, //浏览器语种
      sidebar: state => state.sidebar,
      loginUser: state => state.loginUser,
      tokenInfo: state => state.tokenInfo,
      user: state => state.user,
      overviewData: state => state.overviewData, //概览页数据
      showAside: state => state.showAside
    },
    mutations: {
      // 提交语种类型
      languageTypeChange(state, payload) {
        state.languageType = payload
      },
      //顶部及时沟通未读消息
      messageNumChange(state, payload) {
        state.messageNum = payload
      },
      overviewData(state, payload) {
        state.overviewData = payload
      },
      loginUser(state, payload) {
        state.loginUser = payload
      },
      changeShowAside(state, payload) {
        state.showAside = payload
        //// console.log(payload)
      },
      userMu(state, payload) {
        state.user = payload
      },
      Set_sidebar: (state, layout) => {
        state.sidePath = layout
      },
      setTokenInfo(state, newToken) {
        state.tokenInfo = newToken
        localStorage.setItem('token', newToken)
      }
    },
    actions: {
      userLogin(context, userInfo) {
        context.commit('setTokenInfo', userInfo)
      }
    },
    // 解决vuex 持久存储问题
    plugins: [createPersistedState()]
  }
  // {
  //
  //   modules: {
  //   }
  // }
)
